module.exports = " <div class=top-bar> <button class=left data-cmd=backToDos></button> <button class=right data-cmd=toggleZoom></button> <h2><label>{{ title }}</label></h2> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WinHeader.vue
// module id = 179
// module chunks = 2